import PessoaEntity from "../usuario/PessoaEntity";

export default class UsuarioEntity {
    constructor(public id?: number, public username?: string, public password?: string, public ativo?: boolean) {}
}

export class UsuarioPessoaEntity {
    constructor(public pessoaId?: number, public usuario?: UsuarioEntity, public pessoa?: PessoaEntity) {}
}
